<script module lang="ts">
  import type { IslandProps } from "~/types/islands";

  export interface Props extends IslandProps {
    accountId?: string;
    domainKey?: string;
    rows?: number;
    collectionKey?: string;
    collectionTitle?: string;
    collectionDescription?: string;
    collectionUrl?: string;
    shopUrl?: string;
  }
</script>

<script lang="ts">
  import { QueryClientProvider } from "@tanstack/svelte-query";
  import PlpPage from "./plp/PlpPage.svelte";
  import SearchPage from "./search/SearchPage.svelte";
  import Theme from "~/components/Theme.svelte";

  let {
    name,
    queryClient,
    accountId,
    domainKey,
    rows,
    collectionKey,
    collectionTitle,
    collectionDescription,
    collectionUrl,
    shopUrl,
  }: Props = $props();

  const isDev = import.meta.env.DEV;

  type DevtoolsComponent =
    (typeof import("@tanstack/svelte-query-devtools"))["SvelteQueryDevtools"];
  let Devtools = $state<DevtoolsComponent | null>(null);

  if (isDev) {
    import("@tanstack/svelte-query-devtools").then((mod) => {
      Devtools = mod.SvelteQueryDevtools;
    });
  }
</script>

<QueryClientProvider client={queryClient}>
  <Theme>
    {#if name === "plp"}
      <PlpPage
        {accountId}
        {domainKey}
        {collectionKey}
        {rows}
        {collectionTitle}
        {collectionDescription}
        {collectionUrl}
        {shopUrl}
      />
    {:else}
      <SearchPage {accountId} {domainKey} {rows} />
    {/if}
  </Theme>
  {#if isDev && Devtools}
    <Devtools />
  {/if}
</QueryClientProvider>
